import React from 'react';

import { SatInput } from '@components/common/satUI';

import { NTCE_SCREN_DISP_METH_CD, NOTICE_MAX_LENGTH } from '@common/constants';

/**
 * 계약이전고지화면표시방법코드 (B3)
 * 문구전 숫자값
 * @param {*} props
 * @returns
 */
const NumberInputBeforeAns = props => {
  const {
    isPreUw = false,
    group,
    items,
    tbNbsPolicyBfNtceAnsDtlDTO,
    tbNbsPolicyBfNtceAnsByitmDtlDTO,
    setTbNbsPolicyBfNtceAnsByitmDtlDTO,
    onSave,
  } = props;

  const onChange = (item, value) => {
    let newTbNbsPolicyBfNtceAnsByitmDtlDTO;
    const prevItem = tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
      ({ policyBfNtceItmGrpNo, policyBfNtceItmNo }) =>
        policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
        policyBfNtceItmNo === item.policyBfNtceItmNo,
    );

    if ($utils.isEmptyObject(prevItem)) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = [
        ...tbNbsPolicyBfNtceAnsByitmDtlDTO,
        {
          ansContn: value,
          ansDataTyTpCd: '1',
          policyBfNtceId: '',
          policyBfNtceItmGrpNo: group.policyBfNtceItmGrpNo,
          policyBfNtceItmNo: item.policyBfNtceItmNo,
        },
      ];
    } else {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO.map(
        dtl => {
          if (
            dtl.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
            dtl.policyBfNtceItmNo === item.policyBfNtceItmNo
          ) {
            return {
              ...dtl,
              ansContn: value,
            };
          }
          return dtl;
        },
      );
    }

    setTbNbsPolicyBfNtceAnsByitmDtlDTO(newTbNbsPolicyBfNtceAnsByitmDtlDTO);
    onSave(
      value,
      { group, item },
      {
        tbNbsPolicyBfNtceAnsDtlDTO,
        tbNbsPolicyBfNtceAnsByitmDtlDTO: newTbNbsPolicyBfNtceAnsByitmDtlDTO,
      },
    );
  };

  const getMaxValue = policyBfNtceInsLenContn => {
    if (policyBfNtceInsLenContn.indexOf('N') > -1) {
      const maxNumber = '9';
      const maxLength = NOTICE_MAX_LENGTH[policyBfNtceInsLenContn];

      return Number(maxNumber.repeat(maxLength));
    }
    return null;
  };

  return (
    <ul className="input-list with-txt">
      {items
        .reduce((acc, cur) => {
          if (
            cur.policyBfNtceScrenDispMethdCd === NTCE_SCREN_DISP_METH_CD.NONE
          ) {
            acc.push([cur]);
          } else {
            const latest = acc.pop() || [];
            latest.push(cur);
            acc.push(latest);
          }
          return acc;
        }, [])
        .map(numGrp => (
          <li
            className="divide-2"
            key={`number_${numGrp[numGrp.length - 1].policyBfNtceItmNo}`}
          >
            <div className="inner">
              {numGrp.length === 2 && (
                <strong className="text-con">{numGrp[0].itmDispContn}</strong>
              )}
              <div className="box">
                <SatInput
                  customStyleClass="w-550"
                  type="number"
                  disabled={isPreUw}
                  maxValue={getMaxValue(
                    numGrp[numGrp.length - 1].policyBfNtceInsLenContn,
                  )}
                  title={numGrp[numGrp.length - 1].itmDispContn}
                  outerSuffix={() => {
                    return (
                      <span className="unit-txt">
                        {numGrp[numGrp.length - 1].itmDispContn}
                      </span>
                    );
                  }}
                  value={
                    tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
                      dtl =>
                        dtl.policyBfNtceItmGrpNo ===
                          group.policyBfNtceItmGrpNo &&
                        dtl.policyBfNtceItmNo ===
                          numGrp[numGrp.length - 1].policyBfNtceItmNo,
                    )?.ansContn
                  }
                  onChange={value => {
                    onChange(numGrp[numGrp.length - 1], value);
                  }}
                />
              </div>
            </div>
          </li>
        ))}
    </ul>
  );
};

export default NumberInputBeforeAns;
